export default __webpack_public_path__ + "static/media/1_1.48055547.png";